import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompanyNewFinStatusValue,
  UniversalFilterCompanyNewFinStatusModes,
  UniversalFilterCompanyNewFinStatusOnChange
} from './UniversalFilterCompanyNewFinStatus.types';

import { useUniversalFilterCompanyNewFinStatus } from './hooks/useUniversalFilterCompanyNewFinStatus';

import { TeamNewFinStatusesMultiSelect } from '../../../../../main/teams/helpers/TeamNewFinStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompanyNewFinStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompanyNewFinStatusValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompanyNewFinStatusOnChange;
}

function UniversalFilterCompanyNewFinStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompanyNewFinStatusProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterCompanyNewFinStatus({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterCompanyNewFinStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <TeamNewFinStatusesMultiSelect
        key={filterState.mode}
        value={filterState.statuses || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanyNewFinStatus;
